/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownWrapper, DropdownTrigger, DropdownCaret, DropdownMenu } from './Styled';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    if ('ontouchstart' in document.documentElement) {
      document.body.style.cursor = 'pointer';
    }
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = e => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        isOpen: false
      });
    }
  };

  handleClick = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen
    });
  };

  render() {
    const { trigger, menu, position, withCaret } = this.props;
    const { isOpen } = this.state;
    return (
      <DropdownWrapper ref={this.setWrapperRef}>
        {trigger ? (
          <DropdownTrigger onClick={this.handleClick}>
            {trigger}
            {withCaret ? <DropdownCaret isOpen={isOpen} /> : null}
          </DropdownTrigger>
        ) : null}
        {menu ? (
          <DropdownMenu position={position} isOpen={isOpen}>
            {menu}
          </DropdownMenu>
        ) : null}
      </DropdownWrapper>
    );
  }
}

Dropdown.propTypes = {
  trigger: PropTypes.node.isRequired,
  menu: PropTypes.node.isRequired,
  withCaret: PropTypes.bool,
  position: PropTypes.string
};

Dropdown.defaultProps = {
  withCaret: false,
  position: 'left'
};

export default Dropdown;
